import { render, staticRenderFns } from "./ForgotPasswordElement.vue?vue&type=template&id=1fe40ff2&scoped=true&"
import script from "./ForgotPasswordElement.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe40ff2",
  null
  
)

export default component.exports